import React, { useEffect, useState, useRef} from "react";
import { motion } from "framer-motion";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import { isEmpty, startsWith, size, get } from "lodash";
import EmailValidator from "email-validator";

import {
	Alert,
	AppBar,
	Box,
	Button,
	Container,
	Dialog,
	DialogContent,
	Grid,
	IconButton,
	ImageList,
	ImageListItem,
	ImageListItemBar,
	Slide,
	Switch,
	TextField,
	TextareaAutosize,
	Toolbar,
	Tooltip,
	Typography,
} from "@mui/material";
import {
	Visibility,
	Delete,
	Edit,
	Close,
	PhotoCamera,
	Add,
	Work,
	Storefront,
	Verified,
	Save,
} from "@mui/icons-material";
import SaveIcon from '@mui/icons-material/Save';
import { Widget } from "../../components/widget/Widget";
import Table from "../../components/table/Table";
import Select from "../../components/controls/Select";
import {
	setERR_SOURCE_BUSINESS,
	createSourceBusiness,
	deleteSourceBusiness,
	updateSourceBusiness,
	showLoading,
	getAllSourceBusinessV3,
	deleteSourceBusinessV3,
} from "../../redux/actions/sourceBusiness.actions";
import { getAllUsers } from "../../redux/actions/user.actions";

import "./source_business.scss";
import Loader from "../../components/loader/Loader";
import { getUserDetail } from "../offers/OfferManagement";
import { checkCharSize } from "../../utils/Validations";
import TotalCard from "../../components/comman/cards/TextCards";
import AnimatedButton from "../../components/comman/buttons/buttons";
import DialogBoxContent from "../../components/comman/dialogContent/DialogBoxCon";
import CommonShimmer from "../../components/comman/shimmerTable/ShimmerTable";
import MessageDialog from "../../components/comman/dialogMsg/DialogMsg";
import { toast } from 'react-hot-toast';
import CommonDataTable from "../../components/comman/comman-table/newTable";
import useDebounce from "../../hooks/useDebounce";
import CreateCampaignCard from "../campaigns/component/CardComponent";

const Transition = React.forwardRef(function Transition(props, ref) {
	return <Slide direction='up' ref={ref} {...props} />;
});

const initialFileValues = {
	preview: "",
	data: "",
};

const host = `${process.env.REACT_APP_BASE_URL_VMS}/`;

const SourceBusiness = () => {
	/************************************* FETCH DATA **************************************/
	const { sourceBusinesses, sourceBusiness, loading: shimmerTable } = useSelector(
		(state) => state.sourceBusinessReducer, shallowEqual
	);

	const { startDate, endDate } = useSelector((state) => state?.dateRangeReducer, shallowEqual);


	const { users } = useSelector((state) => state.userReducer);
	const { user } = useSelector((state) => state.authReducer);
	const { errors, loading } = useSelector((state) => state.sourceBusinessReducer);
	const user_id = user.user_id;
	const [show, setShow] = useState(false);
	const [messageShow, setMessageShow] = useState({
		msg: "",
		type: "",
		variant: "",
		id: "",
		color: ""
	});

	const { user_roleid } = user;
	const getAgentCollection = users.map((user) => ({
		id: user.user_id,
		name: user.user_name,
	}));
	const initialFValues = {
		brand_name: "",
		brand_intro: "",
		brand_detail: "",
		state: "",
		website_link: "",
		fb_link: "",
		insta_link: "",
		twitter_link: "",
		poc_name: "",
		poc_num: "",
		poc_email: "",
		status: true,
		agent: "",
		created_by: user_id,
		modified_by: user_id,
	};
	const dispatch = useDispatch();

	const statusToString = (object) => {
		if (object.status === true) {
			return "Active";
		} else {
			return "Inactive";
		}
	};

	const verifiedToString = (object) => {
		if (object.is_verified === true) {
			return "Yes";
		} else {
			return "No";
		}
	};



	/************************************* WIDGET DATA **************************************/
	const active = sourceBusinesses?.data?.map((item) => item.status)
		.filter((item) => item === true);

	/************************************* TABLE DATA **************************************/
	const handleDelete = (id) => {
		setShow(true);
		setMessageShow({
			id: id,
			msg: "Do you want to delete?",
			type: "Delete",
			variant: "error",
			color: "red"
		});
	};



	let columns = [
		{ key: "brand_id", label: "Brand Id" },
		{ key: "brand_name", label: "Brand Name" },
		{ key: "poc_name", label: "Point of Contact" },
		{ key: "poc_num", label: "Contact Number" },
		{ key: "agent", label: "Agent Assigned" },
		{ key: "status", label: "Status" },
		{ key: "is_verified", label: "Verified" },
	];

	/************************************* FORM DATA **************************************/
	const [openForm, setOpenForm] = useState(false);
	const [brand, setBrand] = useState(initialFValues);
	const [fileLogo, setFileLogo] = useState(initialFileValues);
	const [fileIcon, setFileIcon] = useState(initialFileValues);
	const [isEdit, setIsEdit] = useState(false);
	const [updatedVal, setUpdatedVal] = useState({});
	const [showAlert, setShowAlert] = useState(false);
	const [currentBrandName, setCurrentBrandName] = useState("");
	const [page, setPage] = useState(1);
	const [compaignSearch, setCampaignForSearch] = useState('')

	const [formError, setError] = useState({
		brand_name_error: true,
		brand_intro_error: true,
		brand_detail_error: true,
		website_link_error: true,
		poc_name_error: true,
		poc_num_error: true,
		poc_email_error: true,
		agent_assign_error: true,
		logo_error: true,
		icon_error: true,
	});
	const [helperText, setHelpertext] = useState({
		emailText: "Enter valid email",
		numText: "Number of digit must be 10",
		websiteText: "Website name should start with www or https",
	});

	const handleOpenForm = () => {
		dispatch(setERR_SOURCE_BUSINESS({}));

		setOpenForm(true);
		setShowAlert(false);
	};
	const handleCloseForm = () => {
		if (isEdit) {
			console.log("errors.status:", errors, ":showalert:", showAlert);
			if (errors.status !== 200) {
				setShowAlert(false);
			}
			setIsEdit(false);
		} else if (errors.status !== 200) {
			setShowAlert(false);
		}
		changeAllErrorsFlag(true);
		setOpenForm(false);
		setUpdatedVal({});
		setBrand(initialFValues);
		setFileIcon(initialFileValues);
		setFileLogo(initialFileValues);
	};

	const {
		brand_name,
		brand_intro,
		brand_detail,
		state,
		website_link,
		fb_link,
		insta_link,
		twitter_link,
		poc_name,
		poc_num,
		poc_email,
		agent,
	} = brand;

	const handleLogoUpload = (e) => {
		const size = e.target.files[0].size;
		if (size < 50000) {
			const img = {
				preview: URL.createObjectURL(e.target.files[0]),
				data: e.target.files[0],
			};
			setFileLogo(img);
			formError.logo_error = false;
			toast.success('Logo uploaded successfully');
		} else {
			toast.error("Logo size must be less than 50KB");
		}
	};

	const handleIconUpload = (e) => {
		const size = e.target.files[0].size;
		if (size < 50000) {
			const img = {
				preview: URL.createObjectURL(e.target.files[0]),
				data: e.target.files[0],
			};
			setFileIcon(img);
			formError.icon_error = false;
			toast.success('Icon uploaded successfully');
		} else {
			toast.error("Icon size must be less than 50KB");
		}
	};

	const handleInputChange = (e) => {
		if ((e.target.name == "brand_name") && !checkCharSize(e.target.value, 50)) {
			return
		}
		if ((e.target.name == "brand_detail") && !checkCharSize(e.target.value, 100)) {
			return
		}
		if (isEdit) {
			setUpdatedVal({ ...updatedVal, [e.target.name]: e.target.value });
		}
		setBrand({
			...brand,
			[e.target.name]: e.target.value,
		});
		handleCheck(e);
	};

	const handleCheck = (e) => {
		if (e.target.name === "brand_name") {
			if (!isEmpty(e.target.value)) {
				formError.brand_name_error = false;
			} else {
				formError.brand_name_error = true;
			}
		}
		if (e.target.name === "brand_detail") {
			if (!isEmpty(e.target.value)) {
				formError.brand_detail_error = false;
			} else {
				formError.brand_detail_error = true;
			}
		}
		if (e.target.name === "brand_intro") {
			if (!isEmpty(e.target.value)) {
				formError.brand_intro_error = false;
			} else {
				formError.brand_intro_error = true;
			}
		}
		if (e.target.name === "poc_name") {
			if (!isEmpty(e.target.value)) {
				formError.poc_name_error = false;
			} else {
				formError.poc_name_error = true;
			}
		}
		if (e.target.name === "agent") {
			if (!isEmpty(e.target.value)) {
				formError.agent_assign_error = false;
			} else {
				formError.agent_assign_error = true;
			}
		}
		if (e.target.name == "poc_email") {
			if (EmailValidator.validate(brand.poc_email)) {
				helperText.emailText = "";
				formError.poc_email_error = false;
			} else {
				helperText.emailText = "Enter a valid email.";
				formError.poc_email_error = true;
			}
		}
		if (e.target.name == "poc_num") {
			if (e.target.value.length === 10) {
				helperText.numText = "";
				formError.poc_num_error = false;
			} else {
				helperText.numText = "Number of digit must be 10";
				formError.poc_num_error = true;
			}
		}
		if (e.target.name == "website_link") {
			if (e.target.value.length >= 4) {
				helperText.websiteText = "";
				formError.website_link_error = false;
			} else {
				helperText.websiteText = "Website name should start with www or https";
				formError.website_link_error = true;
			}
		}
	};

	const handleEdit = async (id) => {
		const matched = sourceBusinesses?.data?.find(
			(sourceBusiness) => sourceBusiness.brand_id === id?.brand_id
		);

		if (!matched) return;

		try {
			const response = await fetch(
				`${process.env.REACT_APP_BASE_URL_VMS}/api/v3/source_business/${matched.brand_id}`,
				{
					method: "GET",
					headers: {
						"Content-Type": "application/json",
						accessToken: localStorage.getItem("accessToken"),
					},
				}
			);

			const { data: brandData } = await response.json();
			if (!brandData) return;

			setCurrentBrandName(brandData.brand_name || "");

			setBrand(brandData); // set the full object if used in form population

			setFileIcon({
				preview: brandData.icon || "",
				data: brandData.icon,
			});

			setFileLogo({
				preview: brandData.logo || "",
				data: brandData.logo,
			});

			setUpdatedVal((prev) => ({
				...prev,
				brand_id: id?.brand_id,
			}));

			setIsEdit(true);
			changeAllErrorsFlag(false);
			handleOpenForm();

			return brandData;
		} catch (error) {
			console.error("Error fetching brand details:", error);
		}
	};


	function brandNameExists(brand_name) {
		let arr = sourceBusinesses?.data?.filter((item) => item.brand_name.toLowerCase().trim() === brand_name.toLowerCase().trim())
		if (arr.length > 0) {
			return true
		} else {
			return false
		}
	}

	function changeAllErrorsFlag(flag) {
		setError({
			brand_name_error: flag,
			brand_intro_error: flag,
			brand_detail_error: flag,
			website_link_error: flag,
			poc_name_error: flag,
			poc_num_error: flag,
			poc_email_error: flag,
			agent_assign_error: flag,
			logo_error: flag,
			icon_error: flag,
		});
	}

	const handleSubmit = async (e) => {
		e.preventDefault();
		if (isEdit) {
			const updatedFormData = new FormData();
			if (fileLogo?.data instanceof File) {
				updatedFormData.append("logo", fileLogo.data);
			}
			if (fileIcon?.data instanceof File) {
				updatedFormData.append("icon", fileIcon.data);
			}
			updatedFormData.append("modified_by", user_id);
			for (let value in updatedVal) {
				if (value === "brand_name") {
					//check brand_name already exists
					if (updatedVal[value] !== currentBrandName && brandNameExists(updatedVal[value])) {
						toast("Brand Name Already Exist", { icon: "⚠️" });
						dispatch(showLoading(false));
						return;
					}
				}
				if (value !== "logo" && value !== "icon") {
					updatedFormData.append(value, updatedVal[value]);
				}
			}

			dispatch(updateSourceBusiness(updatedVal.brand_id, updatedFormData));
			setShowAlert(true);
			handleCloseForm();
			toast.success('Brand updated successfully');
		} else {
			dispatch(showLoading(true))
			const formData = new FormData();
			formData.append("logo", fileLogo.data);
			formData.append("icon", fileIcon.data);
			for (let item in brand) {
				if (item == "brand_name") {
					//check brand_name already exists
					if (brandNameExists(brand[item])) {
						toast("Brand name is already present.", { icon: "⚠️" })
						dispatch(showLoading(false))
						return
					}
				}
				formData.append(item, brand[item]);
			}
			dispatch(createSourceBusiness(formData));
			setShowAlert(true);
			toast.success('Brand created successfully');
			dispatch(getAllSourceBusinessV3({ page: 1, limit: 10 }));
			if (!isEdit && (errors.status === 200)) {
				handleCloseForm()
			}
		}
	};

	const handleStatusChange = (id, status) => {
		const formData = {
			status,
		};
		dispatch(updateSourceBusiness(id, formData, "status"));
	};

	const handleVerificationChange = (id, is_verified) => {
		const formData = {
			is_verified,
			verified_by: user_id
		};
		dispatch(updateSourceBusiness(id, formData, "verified"));
	};

	const formItems = [
		{
			name: "brand_name",
			label: "Brand name",
			value: brand_name,
			required: true,
			charLimit: true,
			maxLength: 50,
		},
		{
			name: "brand_intro",
			label: "Brand introduction",
			value: brand_intro,
			required: true,
			charLimit: false,
		},
		{
			name: "brand_detail",
			label: "Brand details",
			value: brand_detail,
			required: false,
			charLimit: true,
			maxLength: 100,
		},
		{
			name: "state",
			label: "State",
			value: state,
			required: false,
			charLimit: false,
		},
	];

	const formItemSocial = [
		{
			name: "fb_link",
			label: "Facebook",
			value: fb_link,
			isReq: false,
		},
		{
			name: "twitter_link",
			label: "Twitter",
			value: twitter_link,
			isReq: false,
		},
		{
			name: "insta_link",
			label: "Instagram",
			value: insta_link,
			isReq: false,
		},
	];

	const [displayPOCInputs, togglePOCInputs] = useState(false);
	const handleChangePOC = () => {
		togglePOCInputs(!displayPOCInputs);
	};

	/************************************* POP UP **************************************/
	const initialPValues = {
		"Brand Name": "",
		"Brand Intro": "",
		"Brand Details": "",
		"Website Link": "",
		"Facebook Link": "",
		"Instagram Link": "",
		"Twitter Link": "",
		"Point of Contact": "",
		"POC contact number": "",
		"POC email": "",
		Status: "",
		"Agent Associated": "",
		Verified: "",
		"Verified By": "",
		"Created At": "",
		"Created By": "",
		"Modified At": "",
		"Modified By": "",
	};


	const [openPopup, setOpenPopup] = useState(false);
	const [popupData, setPopupData] = useState(initialPValues);
	const [images, setImages] = useState({
		"Brand Logo": null,
		"Brand Icon": null,
	});

	const handleView = async (id) => {
		const thisBusiness = sourceBusinesses?.data?.find(
			(sourceBusiness) => sourceBusiness.brand_id === id?.brand_id
		);

		if (!thisBusiness) return;

		// Get user details if verified
		let verifiedByUser = null;
		if (thisBusiness.is_verified && thisBusiness.verified_by) {
			verifiedByUser = await getUserDetail(thisBusiness.verified_by);
		}

		setOpenPopup(true);

		setPopupData({
			"Brand Name": thisBusiness.brand_name || "",
			"Brand Intro": thisBusiness.brand_intro || "",
			"Brand Details": thisBusiness.brand_detail || "",
			"Website Link": thisBusiness.website_link || "",
			"Facebook Link": thisBusiness.fb_link || "",
			"Instagram Link": thisBusiness.insta_link || "",
			"Twitter Link": thisBusiness.twitter_link || "",
			"Point of Contact": thisBusiness.poc_name?.trim() || "",
			"POC contact number": thisBusiness.poc_num || "",
			"POC email": thisBusiness.poc_email || "",
			Status: statusToString(thisBusiness),
			"Agent Associated": thisBusiness.agent || "",
			Verified: verifiedToString(thisBusiness),
			"Verified By": thisBusiness.is_verified ? verifiedByUser?.user_name || "" : "",
			"Created At": thisBusiness.created_at || "",
			"Created By": thisBusiness.created_by || "",
			"Modified At": thisBusiness.modified_at || "",
			"Modified By": thisBusiness.modified_by || "",
		});

		setImages({
			"Brand Logo": thisBusiness.logo || "",
			"Brand Icon": thisBusiness.icon || "",
		});
	};


	const handleClosePopup = () => {
		setOpenPopup(false);
	};


	/************************************* USE EFFECT **************************************/
	useEffect(() => {
		dispatch(getAllUsers());
	}, [dispatch]);

	const handleConfirmDelete = () => {
		dispatch(deleteSourceBusinessV3(messageShow.id?.brand_id)).then(() => {
			setShow(false)
			dispatch(getAllSourceBusinessV3(1));
		})
	};
	const handlePageChange = async (page) => {
		setPage(page);
	};


	// console.log(compaignSearch,"sourceBusinesses")
	const debouncedSearch = useDebounce(compaignSearch, 600);
	const debouncedDate = useDebounce(endDate, 600);
	
	const prevSearchRef = useRef(debouncedSearch);
	const prevDateRef = useRef(debouncedDate);

	useEffect(() => {
		const filters = {
			...(debouncedSearch && { search: debouncedSearch }),
			...(startDate && { start_date: startDate }),
			...(endDate && { end_date: endDate }),
		};

		const filterChanged =
			prevSearchRef.current !== debouncedSearch ||
			prevDateRef.current !== debouncedDate;

		prevSearchRef.current = debouncedSearch;
		prevDateRef.current = debouncedDate;

		if (filterChanged) {
			setPage(1);
			dispatch(getAllSourceBusinessV3({ page: 1, limit: 10, ...filters }));
		} else {
			dispatch(getAllSourceBusinessV3({ page, limit: 10, ...filters }));
		}


	}, [debouncedSearch, page, debouncedDate, dispatch]);


	return (
		<Container maxWidth={false} className='source-business'>
			<Grid container direction='column' spacing={2}>
				<Grid item>
					<motion.div
						className='source-business-intro'
						initial={{ opacity: 0, y: -16 }}
						animate={{ opacity: 1, y: 0 }}
						transition={{ duration: 0.45, ease: "easeOut" }}
					>
						<h2>Source Business Overview</h2>
						<p>Monitor brands and active records across source business operations.</p>
					</motion.div>
				</Grid>
				<Grid
					container
					item
					direction='row'
					justifyContent='flex-start'
					spacing={2}
					alignItems='center'>
					<Grid item>
						<TotalCard text={`Total Brands: ${sourceBusinesses?.total}`} icons={<Storefront fontSize="medium" repeat={0} />} color={"#7469f1"} width={"350px"} />
					</Grid>
					<Grid item>
						<TotalCard text={`Active Brands: ${sourceBusinesses?.totalActiveBrands}`} icons={<Verified fontSize="medium" repeat={0} />} color={"#7469f1"} width={"350px"} />
					</Grid>
				</Grid>


				{/***********************  Display table and create new ************************/}
				<Grid item>
					{(user_roleid === 1 || user_roleid === 2 || user_roleid === 3 || user_roleid === 5) && (
						<div className='source-create-card'>
							<CreateCampaignCard onClick={handleOpenForm} btnText={"Create Brand"} heading={"Create New Brand"} />
						</div>
					)}
					{
						loading ?
							<CommonShimmer count={10} /> :
							<CommonDataTable
								data={sourceBusinesses?.data}
								onView={handleView}
								onEdit={handleEdit}
								onDelete={handleDelete}
								onToggleStatus={handleStatusChange}
								onToggleVerified={handleVerificationChange}
								currentPage={page}
								onPageChange={(newPage) => handlePageChange(newPage)}
								showSearch={true}
								totalPages={sourceBusinesses?.totalPages}
								setCompaignForSearch={setCampaignForSearch}
								compaignSearch={compaignSearch}
								columns={columns}
								searchText="Search By Brand Name and Brand ID..."
								dateChange={true}
							/>
					}
				</Grid>
			</Grid>

			{/***********************  Form ************************/}
			<Dialog
				open={openForm && (errors.status !== 200)}
				onClose={handleCloseForm}
				TransitionComponent={Transition}
				fullWidth
				maxWidth='xl'
				scroll='paper'
				PaperProps={{
					sx: {
						borderRadius: 3,
						overflowX: "hidden",
						overflowY: "auto",
						maxHeight: "92vh",
						border: "1px solid transparent",
						background:
							"linear-gradient(155deg, rgba(8, 17, 36, 0.96) 0%, rgba(18, 32, 62, 0.9) 100%) padding-box, linear-gradient(125deg, rgba(56, 189, 248, 0.85) 0%, rgba(59, 130, 246, 0.85) 45%, rgba(99, 102, 241, 0.85) 100%) border-box",
					},
				}}
				BackdropProps={{
					sx: {
						backdropFilter: "blur(6px)",
						backgroundColor: "rgba(2, 6, 23, 0.6)",
					},
				}}
			>
				<AppBar sx={{ position: "relative", background: "linear-gradient(90deg, #1d4ed8 0%, #2563eb 50%, #06b6d4 100%)" }}>
					<Toolbar>
						<IconButton
							edge='start'
							color='inherit'
							onClick={handleCloseForm}
							aria-label='close'>
							<Close />
						</IconButton>
						<Typography sx={{ ml: 2, flex: 1 }} variant='h6' component='div'>
							{isEdit ? "Update Brand" : "Add new brand"}
						</Typography>
						{
							<AnimatedButton
								label={`${isEdit ? "Update Brand" : "Save Brand"}`}
								icon={<SaveIcon />}
								onClick={handleSubmit}
								sx={{
									background: 'linear-gradient(45deg, #ffffff 30%, #ffffff 90%)',
									color: 'black',
									'&:disabled': {
										backgroundColor: '#e0e0e0',
										color: '#9e9e9e',
									},
								}}
								disabled={loading}
							/>
						}
					</Toolbar>
				</AppBar>
				<DialogContent
					dividers
					sx={{
						p: 0,
						overflowY: "auto",
					}}
				>
					{
						loading ?
							(isEdit ? <Loader status={"Updating"} /> : <Loader status={"Creating"} />) :
							<>

								<form action=''>
									<Box
										sx={{
											color: "#ffffff",
											"& .MuiTextField-root": { mt: 4, ml: 6, width: "80%" },
											"& .MuiInputLabel-root": {
												color: "rgba(255,255,255,0.88)",
											},
											"& .MuiInputLabel-root.Mui-focused": {
												color: "#ffffff",
											},
											"& .MuiInputBase-input": {
												color: "#ffffff",
											},
											"& .MuiOutlinedInput-root": {
												backgroundColor: "rgba(255,255,255,0.06)",
												borderRadius: "10px",
											},
											"& .MuiOutlinedInput-notchedOutline": {
												borderColor: "rgba(255,255,255,0.35)",
											},
											"& .MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline": {
												borderColor: "rgba(255,255,255,0.55)",
											},
											"& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline": {
												borderColor: "#67e8f9",
												borderWidth: "2px",
											},
											"& .MuiFormHelperText-root": {
												color: "rgba(255,255,255,0.85) !important",
											},
										}}>
										<Grid container direction='row'>
											<Grid item xs={6}>
												{formItems.map((item) => (
													<TextField
														required={item.required}
														key={item.label}
														variant='outlined'
														size="medium"
														name={item.name}
														label={item.label}
														value={item.value}
														multiline={item.name !== "brand_name" && true}
														onChange={handleInputChange}
														helperText={item.charLimit && `${item.maxLength - (brand[item.name]?.length)} char left`}
													/>
												))}
												<Select
													//key={}
													name='agent'
													label='Agent Assigned'
													value={agent}
													options={getAgentCollection}
													onChange={handleInputChange}
												/>
												<Button
													sx={{ ml: 7, mt: 4, background: '#7469f1', color: 'white', textTransform: 'none' }}
													variant='contained'
													startIcon={<Add />}
													onClick={handleChangePOC}>
													{" "}
													Add point of contact{" "}
												</Button>
												{displayPOCInputs && (
													<>
														<TextField
															required
															key='Name'
															variant='outlined'
															name='poc_name'
															label='Name'
															value={poc_name}
															onChange={handleInputChange}
														/>
														<TextField
															required
															key='Contact Number'
															variant='outlined'
															name='poc_num'
															label='Contact Number'
															value={poc_num}
															helperText={helperText.numText}
															onChange={handleInputChange}
															onKeyPress={(e) => {
																if (!/[0-9]/.test(e.key)) {
																	e.preventDefault();
																}
															}}
															inputProps={{
																maxLength: 10,
																inputMode: 'numeric',
																pattern: '[0-9]*',
																type: 'text'
															}}
														/>
														<TextField
															required
															key='Email'
															variant='outlined'
															name='poc_email'
															label='Email'
															value={poc_email}
															helperText={helperText.emailText}
															onChange={handleInputChange}
														/>
													</>
												)}
											</Grid>
											<Grid container item xs={6} >
												<Grid item>
													<TextField
														required
														key='Website'
														variant='outlined'
														name='website_link'
														label='Website'
														value={website_link}
														helperText={helperText.websiteText}
														onChange={handleInputChange}
													/>
													{formItemSocial.map((item) => (
														<TextField
															required={item.isReq}
															key={item.label}
															variant='outlined'
															name={item.name}
															label={item.label}
															value={item.value}
															onChange={handleInputChange}
														/>
													))}
												</Grid>
												<Grid container item direction='row' >
												<Grid item sx={{
													ml: 6, mt: 3, transition: "all 0.3s ease",
													boxShadow: "0px 4px 20px rgba(0, 0, 0, 0.1)",
													padding: "10px",
													borderRadius: "10px",
													display: "flex",
													alignItems: "center",
													flexDirection: "column",
													marginBottom: "20px",
													maxHeight: "200px",
													justifyContent: "center",
													"&:hover": {
														transform: "scale(1.05)",
														boxShadow: "0px 4px 20px rgba(0, 0, 0, 0.1)",
													},
												}}>
													{" "}
													<div className="d-flex justify-content-center align-items-center flex-column">
														<Button
															required
															variant='outlined'
															sx={{
																background: '#7469f1', color: 'white', textTransform: 'none',
																"&:hover": {
																	transform: "scale(1.05)",
																	boxShadow: "0px 4px 20px rgba(0, 0, 0, 0.1)",
																	background: '#7469f1',
																	color: 'white',
																	border: "none"
																},
															}}
															startIcon={<PhotoCamera />}
															component='label'
															onChange={handleLogoUpload}>
															Upload Logo
															<input
																hidden
																accept='.png, .jpg, .jpeg'
																multiple
																type='file'
															/>
														</Button>
														{formError.logo_error && (
															<Alert
																icon={false}
																severity='warning'
																variant='filled'
																sx={{
																	mt: 1,
																	fontWeight: 700,
																	color: "#111827",
																	backgroundColor: "#facc15",
																}}
															>
																Logo size must be less than 50KB
															</Alert>
														)}
													</div>
													{fileLogo !== initialFileValues && (
														<div className="mt-2" style={{ boxShadow: "0px 4px 20px rgba(0, 2, 2, 0.1)", padding: "10px" }}>
															<img
																width='80'
																height='80'
																src={fileLogo.preview || `https://storage.googleapis.com/public-images-plutosone/cbms/clients/icons/image-1748249203164-error-404-page-not-found-260nw-2359882091 (1).jpg`}
																alt=''
															/>
														</div>
													)}
												</Grid>
												<Grid item sx={{
													ml: 3, mt: 3,
													boxShadow: "0px 4px 20px rgba(0, 0, 0, 0.1)",
													padding: "10px",
													borderRadius: "10px",
													display: "flex",
													alignItems: "center",
													flexDirection: "column",
													marginBottom: "20px",
													maxHeight: "200px",
													justifyContent: "center",
													"&:hover": {
														transform: "scale(1.05)",
														boxShadow: "0px 4px 20px rgba(0, 0, 0, 0.1)",
													},
												}}>
													<div className="d-flex justify-content-center align-items-center flex-column">
														<Button
															variant='outlined'
															startIcon={<PhotoCamera />}
															sx={{
																background: '#7469f1', color: 'white', textTransform: 'none',
																"&:hover": {
																	transform: "scale(1.05)",
																	boxShadow: "0px 4px 20px rgba(0, 0, 0, 0.1)",
																	background: '#7469f1',
																	color: 'white',
																	border: "none"
																},
															}}
															component='label'
															onChange={handleIconUpload}>
															Upload Icon
															<input
																hidden
																accept='.png, .jpg, .jpeg'
																multiple
																type='file'
															/>
														</Button>
														{formError.icon_error && (
															<Alert
																icon={false}
																severity='warning'
																variant='filled'
																sx={{
																	mt: 1,
																	fontWeight: 700,
																	color: "#111827",
																	backgroundColor: "#facc15",
																}}
															>
																Icon size must be less than 50KB
															</Alert>
														)}
													</div>
													{fileIcon !== initialFileValues && (
														<div className="mt-2" style={{ boxShadow: "0px 4px 20px rgba(0, 2, 2, 0.1)", padding: "10px" }}>
															<img
																width='80'
																height='80'
																src={fileIcon.preview || `https://storage.googleapis.com/public-images-plutosone/cbms/clients/icons/image-1748249203164-error-404-page-not-found-260nw-2359882091 (1).jpg`}
																alt=''
															/>
														</div>
													)}
												</Grid>
												</Grid>
											</Grid>
										</Grid>
									</Box>
								</form>
							</>
					}
				</DialogContent>
			</Dialog>
			{/***********************  Detailed Source business popup ************************/}
			<DialogBoxContent
				open={openPopup}
				handleClose={handleClosePopup}
				title={popupData["Brand Name"]}
				images={images}
				data={popupData}
			/>
			{/* Delete Popup */}
			{
				show && (
					<MessageDialog
						open={show}
						onClose={() => setShow(false)}
						title="Delete Brand"
						message={messageShow?.msg}
						okText={messageShow?.type}
						variant={messageShow?.variant}
						img={`https://storage.googleapis.com/public-images-plutosone/cbms/campaign/image-1748122267846-assets_task_01jw2360pqec98vpmf1vxzjzrm_1748122215_img_2.webp`}
						onConfirm={handleConfirmDelete}
					/>
				)
			}

		</Container>
	);
};

export default SourceBusiness;
